import moment from "moment";
import { call, put, takeLatest } from "redux-saga/effects";

import {
  getTokenTransfersSuccess,
  getTokenTransfersFailure,
} from "./TokenTransfers.actions";
import { TokenTransfersService } from "./TokenTransfers.store";

function delay(duration) {
  const promise = new Promise((resolve) => {
    setTimeout(() => resolve(true), duration);
  });
  return promise;
}

function* getTokenTransfersSaga(args) {
  const { token, dateRange, context } = args;
  if (context === "component") {
    while (context === "component") {
      try {
        const tokenTransfersService = new TokenTransfersService();
        const updatedArgs = {
          ...args,
          dateRange: [dateRange[0], moment()],
        };
        const { data, total, rangeTotal } = yield call(
          tokenTransfersService.fetchShortTokenTransfers,
          updatedArgs
        );
        yield put(
          getTokenTransfersSuccess(
            data,
            token,
            dateRange,
            total,
            rangeTotal,
            context
          )
        );
        yield call(delay, 60000);
      } catch (error) {
        yield put(getTokenTransfersFailure(error));
      }
    }
  } else {
    try {
      const tokenTransfersService = new TokenTransfersService();
      const { data, total, rangeTotal } = yield call(
        tokenTransfersService.fetchTokenTransfers,
        args
      );
      yield put(
        getTokenTransfersSuccess(
          data,
          token,
          dateRange,
          total,
          rangeTotal,
          context
        )
      );
    } catch (error) {
      yield put(getTokenTransfersFailure(error));
    }
  }
}

export function* tokenTransfersSagas() {
  const GET_TOKENTRANSFERS = "GET_TOKENTRANSFERS";
  yield takeLatest(GET_TOKENTRANSFERS, getTokenTransfersSaga);
}
